export function replaceSpaces(str: string, param: string = "_"): string {
    let new_str = str.replace(/\s/g, param).trim();

    return new_str;
}
